import React from 'react';
import { DragHandleDisabledIcon } from '../icons/DragHandleDisabledIcon';
import { DragHandleIcon } from '../icons/DragHandleIcon';
import { MinimisedHandleIcon } from '../icons/MinimisedHandle';
export var HandleIconComponent = function HandleIconComponent(props) {
  var forceDefaultHandle = props.forceDefaultHandle,
    isHandleHovered = props.isHandleHovered,
    hasMergedCells = props.hasMergedCells;
  if (isHandleHovered || forceDefaultHandle) {
    return hasMergedCells ? /*#__PURE__*/React.createElement(DragHandleDisabledIcon, null) : /*#__PURE__*/React.createElement(DragHandleIcon, null);
  }
  return /*#__PURE__*/React.createElement(MinimisedHandleIcon, null);
};